// im 用户信息
export const IM_USER_INFO = 'IM_USER_INFO';
